<template>
  <div class="tours">
    <div class="row">
      <div class="col-md-6">
        <h1>Tours</h1>
      </div>
      <div class="col-md-6" style="display: flex; justify-content: end;">
        <router-link to="/tours/create" class="button p-3" v-if="userRole == 1">
          New tour
        </router-link>
        &nbsp;&nbsp;
        <button class="btn btn-outline-info" title="Bulk Uploader" @click="handleCsvUplaoder">
          <span class="icon" :class="(showCsvUplaoder == 'open') ? 'icon--right-arrow' : 'icon--left-arrow'"></span>
        </button>
      </div>
    </div>
    <div class="row mt-5">
      <div :class="(showCsvUplaoder == 'open') ? 'col-md-7' : 'col-md-12'">
        <div class="box">
    
          <form @submit.stop.prevent="doSearch" class="box__header form--inline">
            <input v-model="quickSearch" type="search" placeholder="Quick search">
            <button class="button button--small" type="submit">Search</button>
            &nbsp; &nbsp;
            <div>
              <label for="is_suppressed"> Show suppressed Tours ?</label> <br>
              <label class="switch">
                <input id="is_suppressed" type="checkbox" v-model="showSuppressed" @change="showSuppressedTours">
                <span class="switch__slider"></span>
              </label>
            </div>
          </form>
    
          <vdtnet-table
            id="tour_table"
            ref="table"
            :fields="fields"
            :opts="options"
            @edit="editTour"
            @viewInstance="viewInstance"
            :key="tableKey"
          >
          </vdtnet-table><!-- :details="details" For adding details rows -- currently breaks search though. -->
    
        </div><!-- box -->
      </div>
      <div class="col-md-5" v-if="showCsvUplaoder == 'open'">
        <div v-if="userRole == 1">
          <Csvfileupload />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'datatables.net'
import VdtnetTable from 'vue-datatables-net'
import BulkInstanceUpload from '@/components/BulkInstanceUpload.vue'
import Csvfileupload from '@/components/Csvfileupload.vue'

export default {
  name: 'tours',
  components: {
    VdtnetTable,
    Csvfileupload
  },
  computed: {
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkTableSuppressedChanged()
    });
  },
  beforeDestroy() {
    const tableContainer = this.$el.querySelector('#tour_table');
    if (tableContainer) {
      tableContainer.removeEventListener('change', this.handleSuppressedChange);
    }
  },
  watch: {
      tableKey() {
          this.$nextTick(() => {
              this.checkTableSuppressedChanged();
          });
      },
  },
  data() {
    return {
      tableKey: 0,
      showSuppressed:false,
      options: {
        ajax: {
          url: this.$api + 'tours/table',
          headers: {
            'Accept': 'application/json',
            // 'Authorization': this.$authtoken
            'Authorization': localStorage.getItem('token')
          }
        },
        responsive: false,
        processing: true,
        searching: true,
        searchDelay: 1500,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        dom: 'rtlip',
        autoWidth: false,
        lengthMenu: [ [25, 50, 100, 500], [25, 50, 100, 500] ],
        pageLength: 25,
      },
      fields: {
        name: {
          label: 'Name',
          defaultOrder: 'asc',
          data: 'name',
          render: (data, type, row) => {
            return `<a href="/tours/edit/${ row.id }" data-action="edit">${ data }</a>`
          }
        },
        tour_type: {
          label: 'Tour type',
          searchable: false
        },
        is_suppressed: {
          label: 'Supressed ?',
          render: (data, type, row) => {
            return `<label class="switch">
                      <input id="is_suppressed" type="checkbox" ${(data) ? 'checked' : null} data-type="change_suppressed" data-row-id="${row.id}">
                      <span class="switch__slider"></span>
                    </label>`
          }
        },
        actions: {
          searchable: false,
          sortable: false,
          label: ' ',
          render: (data, type, row) => {
            return `<a href="/tours/edit/${ row.id }" data-action="edit" class="icon icon--more">Edit</a>`
          }
        },
      },
      quickSearch: '',
      details: {
        template: `
          <table cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>Departure date</th>
              <th>Departure airport</th>
              <th>Adult price</th>
              <th>Places</th>
              <th></th>
            </tr>
          </thead>
          <tr v-for="instance in data.instances">
            <td>{{ instance.departure_date }}</td>
            <td>{{ instance.departure_airport }}</td>
            <td>{{ instance.price }}</td>
            <td>{{ instance.tour_places }}</td>
            <td><a :href="'/tours/instances/' + instance.id" class="icon icon--more">Edit</a></td>
          </tr>
          </table>
        `
      },
      showCsvUplaoder: 'close',
    }
  },
  methods: {
    doSearch() {
      this.$refs.table.search(this.quickSearch)
    },
    editTour(data) {
      this.$router.push({ name: 'tour-edit', params: { id: data.id }})
    },
    viewInstance(data) {
      this.$router.push({ name: 'tour-instance', params: { id: data.id }})
    },
    checkTableSuppressedChanged() {
      const tableContainer = this.$el.querySelector('#tour_table');
      if (tableContainer) {
          tableContainer.addEventListener('change', this.handleSuppressedChange);
      }
    },
    handleSuppressedChange(event) {
      if (event.target && event.target.matches('input[data-type="change_suppressed"]')) {
        const rowId = event.target.getAttribute('data-row-id');
        const isChecked = event.target.checked;
        // Call your API here
        this.updateSuppressedStatus(rowId, isChecked);
      }
    },
    updateSuppressedStatus(rowId, isSupressed) {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}tours/update/tour-suppression`, {
          method: 'POST',
          body: JSON.stringify({
              tour_id : rowId,
              supression: (isSupressed) ? 'yes' : 'no'
          }),
          headers:{
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization': localStorage.getItem('token')
          }
      })
      .then(res => res.json())
      .then(response => {
          if (response.status) {
            this.$notify({
              type: 'success',
              title: response.message
            });
            this.tableKey++
          } else {
            this.$notify({
              type: 'error',
              title: response.message
            });
          }
      })
      .catch ((error) => {
        this.$notify({
          type: 'error',
          title: error
        });
      })
      .finally(() => {
        this.$store.dispatch('setLoadStatus')
      });
    },
    showSuppressedTours() {

      const ajaxUrl = this.$api + 'tours/table'

      const queryString = new URLSearchParams();

      if (this.showSuppressed) {
        queryString.set('show_only_suppressed', 'yes');
      }

      const urlWithParams = `${ajaxUrl}?${queryString.toString()}`;

      // Update the datatable's AJAX URL with the Start Date & End Date query parameters
      this.options.ajax.url = urlWithParams;

      // Increment the tableKey to force re-render and fetch new data
      this.tableKey++;

    },
    handleCsvUplaoder() {
      if (this.showCsvUplaoder == 'open') {
        this.showCsvUplaoder = 'close';
      } else {
        this.showCsvUplaoder = 'open';
      }
    }
  }

}

</script>
